import React, { useContext, useEffect, useState } from "react";
import { ContextProfileUser } from "../../lib/profileContext";

import "./BirthdayForm.scss";

import ProgressDots from "../ProgressDots/ProgressDots";
import SelectGlobal from "../SelectGlobal";
import ButtonSubmit from "../ButtonSubmit";

import { errorEventsBirthday } from "../../constants";
import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  simplyClick,
  validateAge,
} from "../../helpers";

const BirthdayForm = ({ nextStep }) => {
  const { data, setData } = useContext(ContextProfileUser);

  const [errorDate, setErrorDate] = useState({
    month: false,
    day: false,
    year: false,
    message: null,
  });

  useEffect(() => {
    if (data.month && data.day && data.year) {
      setErrorDate({ month: false, day: false, year: false, message: null });
    }
  }, [data.month, data.day, data.year]);

  const handlerSubmit = (e) => {
    e.preventDefault();

    const hasMonth = Boolean(data.month);
    const hasDay = Boolean(data.day);
    const hasYear = Boolean(data.year);

    if (!hasMonth || !hasDay || !hasYear) {
      const dateKey = [
        hasMonth ? "M" : "",
        hasDay ? "D" : "",
        hasYear ? "Y" : "",
      ].join("");

      if (errorEventsBirthday[dateKey]) {
        simplyClick(errorEventsBirthday[dateKey]);
      } else {
        simplyClick("err_lnd_age_nodate");
      }

      setErrorDate({
        month: !hasMonth,
        day: !hasDay,
        year: !hasYear,
        message: "Please enter your date of birth",
      });
      return;
    }

    const { error, status, errors } = validateAge(
      data.month,
      data.day,
      data.year
    );

    if (!status) {
      setErrorDate({
        month: errors.month || errors.invalidDate,
        day: errors.day || errors.invalidDate,
        year: errors.year || errors.invalidDate,
        message: error,
      });
      return;
    }
    const formattedDate = getBirthdayInFormat(data.year, data.month, data.day);

    setData((prev) => ({
      ...prev,
      birthday: formattedDate,
    }));

    simplyClick("cl_lnd_age_st4_action", { text: "next" });
    nextStep();
  };

  const handleChangeField =
    (field) =>
    ({ target: { value } }) => {
      setData((prev) => ({
        ...prev,
        [field]: value,
      }));

      setErrorDate((prev) => ({ ...prev, [field]: false }));

      simplyClick("cl_lnd_age_st4_choose_date", {
        text: `${field}_choose (${value})`,
      });
    };

  return (
    <div className="promo__wrapper-birthday">
      <div className="user__form-top">
        <h3>My date of birth</h3>
      </div>
      <form className="form__date" onSubmit={handlerSubmit}>
        <div className="dates_error">
          <div className="date__wrapper">
            <SelectGlobal
              dateArray={getMonths()}
              data={data.month}
              handleChange={handleChangeField("month")}
              label="Month"
              error={errorDate.month}
              useIndexAsValue={true}
            />
            <SelectGlobal
              dateArray={getDate()}
              data={data.day}
              handleChange={handleChangeField("day")}
              label="Day"
              error={errorDate.day}
            />
            <SelectGlobal
              dateArray={getYears()}
              data={data.year}
              handleChange={handleChangeField("year")}
              label="Year"
              error={errorDate.year}
            />
          </div>

          {errorDate.message && (
            <p className="errorDate">{errorDate.message}</p>
          )}
        </div>

        <div className={"birthday_confirm"}>
          By proceeding, you confirm you are at least 18 years old and fully
          legally capable of using our website.
        </div>

        <ButtonSubmit
          className={"button__global button__birthday"}
          text={"NEXT"}
        />
        <ProgressDots total={12} activeCount={4} />
      </form>
    </div>
  );
};

export default BirthdayForm;
